/* eslint-disable max-len */
import 'react';

const ArrowNewRightFillSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38008_18183" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_38008_18183)">
            <path d="M6.84766 5.53223L9.15166 7.81904L6.84766 10.4682" stroke="#3377FF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
);
export default ArrowNewRightFillSvg;
